import apiClient from "../apiClient";

export function fetchNotificationsApi() {
  return apiClient
    .get("/admin/notifications")
    .then((res) => res.data.notificationHistory); // <-- Only return the array
}